import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './pages/layout/layout.component';
import { AuthGuard, Constants } from './_utility';
import { HomeComponent } from './pages/home/home.component';
import { LandingComponent } from './pages/landing/landing.component';
import { LoginComponent } from './pages/login/login.component';
import { SelectUserComponent } from './pages/select-user/select-user.component';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { SummaryComponent } from './pages/summary/summary.component';
import { CompleteReservationComponent } from './pages/complete-reservation/complete-reservation.component';

const routes: Routes = [
  { path: '', redirectTo: '/landing', pathMatch: 'full' },
  { path: Constants.Routing.LANDING.path, component: LandingComponent },
  { path: Constants.Routing.LOGIN.path, component: LoginComponent },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: Constants.Routing.HOME.path,
        component: HomeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: Constants.Routing.SELECT_USER.path,
        component: SelectUserComponent,
        canActivate: [AuthGuard],
      },
      {
        path: Constants.Routing.CALENDAR.path,
        component: CalendarComponent,
        canActivate: [AuthGuard],
      },
      {
        path: Constants.Routing.SUMMARY.path,
        component: SummaryComponent,
        canActivate: [AuthGuard],
      },
      {
        path: Constants.Routing.COMPLETE_RESERVATION.path,
        component: CompleteReservationComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  { path: '**', redirectTo: '/not-found' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
